import { render, staticRenderFns } from "./selectmultiple.vue?vue&type=template&id=55f73710&scoped=true"
import script from "./selectmultiple.vue?vue&type=script&lang=js"
export * from "./selectmultiple.vue?vue&type=script&lang=js"
import style0 from "./selectmultiple.vue?vue&type=style&index=0&id=55f73710&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f73710",
  null
  
)

export default component.exports